/**
 * index.jsx
 *
 * @Author: jruif
 * @Date: 2018/7/17 下午5:26
 */

import React from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { connect } from 'react-redux';
import captcha from './captcha';

const postCaptchaId = '7131d5de28a14a30bd400b8898c1b822';
const phoneCaptchaId = 'a4eaffd275144f3eac6df03cdbc712c6';

class index extends React.PureComponent {
  static displayName = 'index';

  static propTypes = {
    done: PropTypes.func.isRequired,
    mode: PropTypes.string,
  };

  static defaultProps = {
    width: 280,
    mode: 'embed',
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {
    if (!document.getElementById('cstaticdun')) {
      const cstaticdun = document.createElement('script');
      cstaticdun.id = 'cstaticdun';
      cstaticdun.src = '//cstaticdun.126.net/load.min.js';
      cstaticdun.onload = this.init;
      document.body.appendChild(cstaticdun);
    } else {
      this.init();
    }
  }

  init = () => {
    const { onReady, done, onLoad, fail, width, tracker, wemediaId, mode } = this.props;
    // 文档地址：
    // http://support.dun.163.com/documents/15588062143475712?docId=150442915877015552
    captcha(
      {
        captchaId: ['article', 'gallery'].indexOf(tracker) !== -1 ? postCaptchaId : phoneCaptchaId,
        element: '#captcha',
        mode, // 验证码模式，三种模式可选："float"、"embed"、"popup"，即触发式、嵌入式、弹出式。
        width,
      },
      {
        onReady,
        done,
        onLoad,
        fail,
        tracker,
        wemediaId,
      },
    );
  };

  render() {
    const {} = this.props;
    return <div id="captcha" />;
  }
}

export default index;
